import React from "react";
import { motion } from "framer-motion";
import SectionHead from "./SectionHead";
import Tilt from "./Tilt";
import { img, initials, inView, rise, stagger } from "./utils";

const Avatar = ({ m, className }) => (
  <div className={className} aria-hidden={!m.image}>
    {m.image ? <img src={img(m.image)} alt={m.name} loading="lazy" /> : <span>{initials(m.name)}</span>}
  </div>
);

// compact card used for experts and staff
const Person = ({ m }) => (
  <Tilt as="article" className="au-expert" variants={rise} max={6}>
    <Avatar m={m} className="au-expert__photo" />
    <div>
      <span className="au-expert__role">{m.designation}</span>
      <strong>{m.name}</strong>
      {m.qualification && <small>{m.qualification}</small>}
      {(m.expertise || m.description) && <p>{m.expertise || m.description}</p>}
    </div>
  </Tilt>
);

const Team = ({ team = [] }) => {
  // the API sends team_type as text: leadership | expert | staff
  const leadership = team.filter((m) => m.team_type === "leadership");
  const experts = team.filter((m) => m.team_type === "expert");
  const staff = team.filter((m) => m.team_type === "staff");
  if (!leadership.length && !experts.length && !staff.length) return null;

  return (
    <section id="team" className="au-sec au-sec--pale">
      <div className="au-wrap">
        {leadership.length > 0 && (
          <div className="au-team-group">
            <SectionHead eyebrow="The people" title="Our team" lede="The people behind every pair." />
            <motion.div className="au-lead" variants={stagger} initial="hide" whileInView="show" viewport={inView}>
              {leadership.map((m) => (
                <Tilt as="figure" key={m.id} className="au-lead__item" variants={rise} max={8}>
                  <Avatar m={m} className="au-lead__photo" />
                  <figcaption>
                    <strong>{m.name}</strong>
                    <span>{m.designation}</span>
                    {m.description && <p>{m.description}</p>}
                  </figcaption>
                </Tilt>
              ))}
            </motion.div>
          </div>
        )}

        {experts.length > 0 && (
          <div className="au-team-group">
            <SectionHead eyebrow="Vision care" title="Meet our experts" lede="Qualified specialists who guide you at every step." />
            <motion.div className="au-experts" variants={stagger} initial="hide" whileInView="show" viewport={inView}>
              {experts.map((m) => (
                <Person key={m.id} m={m} />
              ))}
            </motion.div>
          </div>
        )}

        {staff.length > 0 && (
          <div className="au-team-group">
            <SectionHead eyebrow="Every day" title="Behind the scenes" lede="The team that keeps the store running." />
            <motion.div className="au-experts" variants={stagger} initial="hide" whileInView="show" viewport={inView}>
              {staff.map((m) => (
                <Person key={m.id} m={m} />
              ))}
            </motion.div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Team;